var map = {
	"./bachelor-of-science-visualization-min.webp": 4348,
	"./game-design-and-development-min.webp": 607,
	"./master-of-fine-arts-visualization-min.webp": 2472,
	"./master-of-science-visualization-min.webp": 8976,
	"./phd-architecture-min.webp": 3390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8091;